enum SidebarMenus {
	myPages = 'MyPagesMenu',
	cms = 'CmsMenu',
	info = 'InfoMenu',
}

export default SidebarMenus